import { useLazyQuery, useMutation } from '@apollo/client';
import ExamGuideContainer from '../../components/ExamGuideContainer/ExamGuideContainer';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import PDFViewer from '../../components/PDFViewer/PDFViewer';
import FileUpload from '../../components/Popups/FileUpload';
import { DELETE_EBOOK_MATERIAL, DELETE_EBOOK_MATERIAL_ADMIN, UPDATE_EBOOK_MATERIAL, UPDATE_EBOOK_MATERIAL_ADMIN, UPLOAD_MATERIAL, UPLOAD_MATERIAL_ADMIN, VIEW_ALL_EBOOK_MATERIAL, VIEW_ALL_MATERIAL_ADMIN } from '../TeacherTeachingMaterial/api/TeacherTeachingMaterialQuery';
import './TeacherExaminationGuide.scss';
import { useEffect, useState } from 'react';
import ToasterWithMessage from '../../components/toaster';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import { useAppSelector } from '../../redux/app/hooks';
import { FETCH_POLICY, MYLIBRARY_TEXTS, PATH_ADDRESSES, SCHOOL_ADMIN, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR, TEACHER_ROLE } from '../../utils/constants';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import images from '../../assets/images';
import { getScreenDimensions } from '../../utils/helper';
import { EDIT_MYLIBRARY_MATERIALS } from '../ImageMaterial/api/ImageMaterialQuery';
import CommonBulkUpload, { BulkFileState } from '../../components/Popups/CommonBulkUpload/CommonBulkUpload';
import { UploadedFilePayload } from '../SyndicatedVideos/SyndicatedVideos';
import UploadResultModal, { UploadResult, UploadResultForTeacher } from '../AdminBulkUpload/components/UploadResultModal';

export interface guidesData {
    filename: string;
    filepath: string;
    filesize: number;
    isclassroom: boolean;
    coverimagepath: string;
    authorname: string;
    fileId: string;
    feedId? : string;
};

const TeacherExaminationGuide = () => {
    const [url, setUrl] = useState<string>();
    const [filename, setFilename] = useState<string>();
    const [pdfFileData, setPdfFileData] = useState<guidesData | undefined>();
    const [fileData, setFileData] = useState<File | null>();
    const [guideCoverUrl,setGuideCoverUrl] = useState<string>();
    const [guideAuthorName, setGuideAuthorName] = useState<string>();
    const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [openPdf, setOpenPdf] = useState(false);
    const [guidesData, setGuidesData] = useState<[guidesData]>();
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadFailed, setUploadFailed] = useState<boolean>(false);
    const [uploadFileName, setUploadFileName] = useState<string>('');
    const [materialAction,setMaterialAction] = useState<string>('');
    const [uploaded, setuploaded] = useState(false);
    const { success, error } = ToasterWithMessage();
    const { state } = useLocation();
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const role = useAppSelector((state) => state.auth.role);
    const backNavigation = role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials" :role ===STUDENT_ROLE ? '/student-classroom/ebooks/materials' : '/teacher-classroom/ebooks/materials';
    const navigate = useNavigate();
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const { uploadCloud } = images;
     const selectedClassroomIdAdmin = useAppSelector(
        (state) => state.CommonUpload.classroomId
      );

    const [isEditExaminationGuide, setIsEditExaminationGuide] = useState<boolean>(false);
    const [hasSubmittedForEdit, setHasSubmittedForEdit] = useState<boolean>(false);

    const [FilesStatusData, setFilesStatusData] = useState<Array<BulkFileState>>([]);
    const [uploadedPayloads, setUploadedPayloads] = useState<UploadedFilePayload[]>([]);
    const [totalProgress, setTotalProgress] = useState<number>(0);
    const [successCount, setSuccessCount] = useState<number>(0);
    const [failureCount, setFailureCount] = useState<number>(0);
    const [uploadResults, setUploadResults] = useState<UploadResult[]>([]);
    const [upoloadResultsForTeacher, setUploadResultsForTeacher] = useState<UploadResultForTeacher>();
    const [isModalOpen, setIsModalOpen] = useState(false);


       const [editExaminationGuide] = useMutation(EDIT_MYLIBRARY_MATERIALS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            console.log("[Log] editExaminationGuide", data);
           if(data?.editMylibraryEbookMaterial) {
                setFileData(null);
                if(!(fileData && url)) {
                    success("File updated successfully!");
                }
                if(fileData && url) {
                    if (filename) {
                        setUploadFileName(filename);
                    }
                    setuploaded(true);
                    setUploadProgress(100);
                }
                setFilename('');
                setUrl('');
                setGuideCoverUrl('');
                setGuideAuthorName('');
                setHasSubmittedForEdit(false);
                setMaterialAction('');
                if(role === SCHOOL_ADMIN){
                    getAllExaminationGuideAdmin({
                    variables: {
                        typeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                        subjectId: selectedSubjectId,
                        searchInput: "%%",
                        classroomIds : [selectedClassroomIdAdmin]
                    },
                    });
                } else {
                    getAllExaminationGuide({
                        variables: {
                            lId: selectedLibraryId,
                            sjId: selectedSubjectId,
                            type: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                            cId: selectedClassRoomId,
                            limit: null,
                            offset: null,
                            searchInput: '%',
                            orderByColumn: null,
                            orderByDirection: null,
                            isclassroom: role === STUDENT_ROLE ? true : [true, false],
                        }
                    })
                }
           }
        },
        onError: (err) => {
            error(err?.message);
            if (filename) {
                setUploadFileName(filename);
            }
            if(fileData && url) {
                setuploaded(true);
                setUploadProgress(0);
                setUploadFailed(true);
            }
        }
    });

    const [getAllExaminationGuide, { loading }] = useLazyQuery(VIEW_ALL_EBOOK_MATERIAL, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.getMaterialsFromEbookType?.nodes) {
                setGuidesData(data?.getMaterialsFromEbookType?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

     const [getAllExaminationGuideAdmin, {loading : AdminLoading } ] = useLazyQuery(VIEW_ALL_MATERIAL_ADMIN, {
             fetchPolicy: FETCH_POLICY,
                 onCompleted: (data) => {
                     if (data?.getMylibraryEbooksForAdmin?.nodes) {
                         setGuidesData(data?.getMylibraryEbooksForAdmin?.nodes);
                     }
                 },
                 onError: (err) => {
                     error(err?.message);
                     console.error(err?.message)
                 }
             }) 


    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })
    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(guidesData && guidesData.length > 0){
        guidesData?.forEach((data) => {
          if (data.feedId) {
            readFeed({
              variables: {
                fId: data.feedId,
                uId: profile?.getCurrentUser?.nodes[0]?.uId
              }
            })
          }
        });
      }
    }
      },[guidesData, profile?.getCurrentUser?.nodes, readFeed, role])

    const [uploadExaminationGuide] = useMutation(UPLOAD_MATERIAL, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadMultipleMylibraryEbookMaterials?.json) {
                setUploadedPayloads([]);
                const result = data?.uploadMultipleMylibraryEbookMaterials?.json || {};
                setUploadResultsForTeacher(result);

                const hasFailures =
                result.failed_count > 0 ||
                result.results.some((item: any) => item.status === "error");

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }

                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                setGuideCoverUrl('');
                setGuideAuthorName('');
                getAllExaminationGuide({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: '%',
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                })
            }
        },
        onError: (err) => {
            setUploadedPayloads([]);
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

    const [uploadExaminationGuideAdmin] = useMutation(UPLOAD_MATERIAL_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadMylibraryEbooksBySchoolAdmin) {
                setUploadedPayloads([]);

                const result = data.uploadMylibraryEbooksBySchoolAdmin?.result || [];

                setUploadResults(result);

                const hasFailures = result.some(
                    (res: UploadResult) => res.classrooms_failed.length > 0
                );

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }

                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                setGuideCoverUrl('');
                setGuideAuthorName('');
                 getAllExaminationGuideAdmin({
                   variables: {
                     typeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                     subjectId: selectedSubjectId,
                     searchInput: "%%",
                     classroomIds : [selectedClassroomIdAdmin]
                   },
                 });
            }
        },
        onError: (err) => {
            setUploadedPayloads([]);
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

    const [updateExaminationGuide] = useMutation(UPDATE_EBOOK_MATERIAL, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.updateEbookMaterials) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                getAllExaminationGuide({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: '%',
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                })
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

     const [updateExaminationGuideAdmin] = useMutation(UPDATE_EBOOK_MATERIAL_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.updateEbookMaterialsBySchoolAdmin) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
               getAllExaminationGuideAdmin({
                 variables: {
                   typeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                   subjectId: selectedSubjectId,
                   searchInput: "%%",
                               classroomIds : [selectedClassroomIdAdmin]

                 },
               });
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [deleteExaminationGuide] = useMutation(DELETE_EBOOK_MATERIAL, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.deleteEbookMaterials) {
                success("Deleted successfully");
                getAllExaminationGuide({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: '%',
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                })
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

     const [deleteExaminationGuideAdmin] = useMutation(DELETE_EBOOK_MATERIAL_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.deleteEbookMaterialsBySchoolAdmin) {
                success("Deleted successfully");
                getAllExaminationGuideAdmin({
                 variables: {
                   typeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                   subjectId: selectedSubjectId,
                   searchInput: "%%",
                               classroomIds : [selectedClassroomIdAdmin]

                 },
               });
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    useEffect(() => {
        if(role === SCHOOL_ADMIN){
        getAllExaminationGuideAdmin({
          variables: {
            typeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
            subjectId: selectedSubjectId,
            searchInput: "%%",
                        classroomIds : [selectedClassroomIdAdmin]

          },
        });
        
        }else{
        getAllExaminationGuide({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                type: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                cId: selectedClassRoomId,
                limit: null,
                offset: null,
                searchInput: '%',
                orderByColumn: null,
                orderByDirection: null,
                isclassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        });
    }
    }, []);

    useEffect(() => {
        if (materialAction === 'edit' && hasSubmittedForEdit) {
            console.log("inside edit", fileData, filename, url, guideAuthorName, guideCoverUrl);
            let newFileName;
            let newFilePath;
            let newFileSize;
            let newCoverImagePath;
            let newAuthorName;
            let newFileType;

             if(filename !== pdfFileData?.filename){
                newFileName = filename?.replace(/\.pdf$/, "")?.trim();
            }
            if(url && fileData) {
                newFilePath = url;
                newFileSize = fileData?.size;
            }
            if(fileData) {
                newFileType = 'pdf';
            }
            if(guideAuthorName !== pdfFileData?.authorname){
                newAuthorName = guideAuthorName?.trim();
            }
            if(guideCoverUrl && guideCoverUrl !== pdfFileData?.coverimagepath) {
                newCoverImagePath = guideCoverUrl;
            }

            console.log("after assignment", newFileName, newFilePath, newFileSize, newAuthorName, newCoverImagePath);
            editExaminationGuide({
                variables: {
                    fileId: pdfFileData?.fileId,
                    classroomId: (role === SCHOOL_ADMIN) ? [selectedClassroomIdAdmin] : selectedClassRoomId,
                    subjectId: selectedSubjectId,
                    typeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                    ...(newAuthorName && { newAuthorName: newAuthorName }),
                    ...(newCoverImagePath && { newCoverImage: newCoverImagePath }),
                    ...(newFileName && { newFilename: newFileName }),
                    ...(newFilePath && newFileSize && { newFilepath: newFilePath }),
                    ...(newFilePath && newFileSize && { newFilesize: newFileSize }),
                    ...(newFileType && { newFiletype: newFileType })
                }
            });
        }
    }, [fileData, filename, url, guideAuthorName, guideCoverUrl]);

    const formatUploadedPayloads = (
        uploadedPayloads: UploadedFilePayload[],
        guideCoverUrl: string | undefined,
        guideAuthorName: string | undefined,
    ) => {

      const isSingle = uploadedPayloads.length === 1;

      return uploadedPayloads.map((item) => {
    
        return {
            filename: item.filename?.replace(/\.pdf$/, "")?.trim(),
            filepath: item.filepath,
            filesize: item.filesize,
            isClassroom: false,
            filetype: item?.filetype,
            coverImagePath: guideCoverUrl || null,
            authorName: isSingle ? guideAuthorName || null : item?.authorName || null,
        };
        });
    };
    
        useEffect(() => {
            if(uploadedPayloads.length > 0 ){
                const updatedFormattedPayload = formatUploadedPayloads(
                    uploadedPayloads,
                    guideCoverUrl,
                    guideAuthorName
                );
                if(role === SCHOOL_ADMIN){
                    uploadExaminationGuideAdmin({
                        variables: {
                            typeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                            subjectId: selectedSubjectId,
                            classroomIds: [selectedClassroomIdAdmin],
                            files: updatedFormattedPayload
                        },
                    });
                } else if(role === TEACHER_ROLE) {
                    uploadExaminationGuide({
                        variables: {
                        libraryId: selectedLibraryId,
                        subjectId: selectedSubjectId,
                        classroomId: selectedClassRoomId,
                        typeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                        files: updatedFormattedPayload
                        },
                    });
                }
            }
        }, [ uploadedPayloads ]);

    //To open pdf in detailed view
    const handleOpenFile = (pdfData: guidesData) => {
        setOpenPdf(true);
        setPdfFileData(pdfData);
    }

    //To close pdf detailed view
    const handleClosePdf = () => {
        setOpenPdf(false);
        setPdfFileData(undefined);
    }

    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setOpen(true);
    };

    //To done actions in materials
    const handleMaterialActions = (data: guidesData, action: string) => {
        if (action === "share") {
            setMaterialAction("share");
            if(role === SCHOOL_ADMIN){
                 updateExaminationGuideAdmin({
                   variables: {
                     input: {
                        pSubjectId: selectedSubjectId,
                        pFileId: data?.fileId,
                        pIsClassroom: true,
                        pTypeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                        pClassroomIds: [selectedClassroomIdAdmin],
                    },
                    },
                    });
                }else{
            updateExaminationGuide({
                variables: {
                    isClassroom: true,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        }
        } else if (action === "undoShare") {
            setMaterialAction("undoShare");
             if(role === SCHOOL_ADMIN){
              updateExaminationGuideAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: false,
                    pTypeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updateExaminationGuide({
                variables: {
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        }
        } else if (action === "delete") {
            setMaterialAction('');
            if(role === SCHOOL_ADMIN){
            deleteExaminationGuideAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pTypeName: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            deleteExaminationGuide({
                variables: {
                    cId: selectedClassRoomId,
                    fId: data?.fileId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT
                }
            })
        }
        } else if (action === "edit") {
            setMaterialAction('edit');
            setIsEditExaminationGuide(true);
            setIsUploadOpen(true);
            setOpen(true);
            setPdfFileData(data);
        }
    };

    return (
        <div className={`teacherExaminationGuide ${role === SCHOOL_ADMIN ? "schoolAdminMaterials":""}`}>
            <LibraryHeader
                image={state?.imageSrc}
                backgroundColor={state?.backGroundColor}
                subject={state?.title}
                subCategory={'Examination Guideline'}
                setIsUploadOpen={setIsUploadOpen}
                openPdf={openPdf}
                onClose={handleClosePdf}
                setOpen={setOpen}
                backNavigation={{ path: backNavigation, state: state }}
            />
            {
                openPdf ?
                    <PDFViewer file={pdfFileData?.filepath ? baseUrl + pdfFileData.filepath : ''} pdfFileData={pdfFileData} onClose={handleClosePdf} type={MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT} />
                    :
                    <>
                        {
                            loading || AdminLoading ? <Loader bottom='165px' />
                                :
                                <div className='teacherExaminationGuideBody'>
                                    <ExamGuideContainer
                                        guidesData={guidesData}
                                        handleOpenFile={handleOpenFile}
                                        handleMaterialActions={handleMaterialActions}
                                        from = "examinationGuides"
                                    />
                                </div>
                        }
                    </>
            }
            {/* {isUploadOpen && <FileUpload type='pdf' name="Examination Guide" setGuideAuthorName = {setGuideAuthorName} setCoverImageUrl ={setGuideCoverUrl} setUrl={setUrl} open={open} setOpen={setOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} />} */}
            {isUploadOpen && !isEditExaminationGuide && <CommonBulkUpload page="Teacher examination" type='pdf' name={MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT} setUploadedPayloads = {setUploadedPayloads} setFilesStatusData = {setFilesStatusData} setTotalProgress = {setTotalProgress} setSuccessCount = {setSuccessCount} setFailureCount = {setFailureCount} setGuideAuthorName = {setGuideAuthorName} setCoverImageUrl ={setGuideCoverUrl} setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName}/>}
            {isUploadOpen && isEditExaminationGuide && pdfFileData &&  <FileUpload page="Teacher examination" type='pdf' setHasSubmittedForEdit={setHasSubmittedForEdit} setMaterialAction={setMaterialAction} selectedFileData={pdfFileData} isEdit = {isEditExaminationGuide} setIsEdit = {setIsEditExaminationGuide} name={MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT} setGuideAuthorName = {setGuideAuthorName} coverImageUrl={guideCoverUrl} setCoverImageUrl ={setGuideCoverUrl} setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName}/>}
            {uploaded && <UploadToaster successCount = {successCount} failureCount={failureCount} FilesStatusData = {FilesStatusData} setFilesStatusData = {setFilesStatusData} totalProgress = {totalProgress} setTotalProgress = {setTotalProgress} uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />}
            <UploadResultModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                results={uploadResults}
                uploadResultsForTeacher = {upoloadResultsForTeacher}
                page='teacherMaterialDirectClass'
            />
            {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !openPdf &&
                            <div className='libraryHeaderUploadContainer'> 
                                <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                                    <img src={uploadCloud} alt="upload" className='uploadImage' />
                                </div>
                            </div>}
        </div>
    )
}

export default TeacherExaminationGuide;
